export enum Mood {
  neutral = "neutral",
  verySad = "very-sad",
  sad = "sad",
  okay = "okay",
  happy = "happy",
  ecstatic = "ecstatic",
}
